import Model from 'core/model/Model';

/**
 * A single revision of the Custom Network Context (CNC).
 *
 * The version history is an append-only log: each row is uniquely identified by
 * its `version` number rather than a row id. The version list endpoint returns
 * only metadata (version, cdate, comment, user); the prompt body (`context`) is
 * loaded lazily from the per-version endpoint via `fetch()`.
 */
class CustomNetworkContextModel extends Model {
  get urlRoot() {
    return '/api/ui/ai/context';
  }

  // Content lives at the per-version endpoint, not `${urlRoot}/${id}`.
  get url() {
    return `${this.urlRoot}/versions/${this.get('version')}`;
  }

  get version() {
    return this.get('version');
  }

  get sortValues() {
    return { version: (model) => Number(model.get('version')) };
  }

  get hasContent() {
    return this.get('context') !== undefined;
  }

  get needsFetch() {
    return !this.hasContent && this.requestStatus !== 'fetching';
  }

  fetchContent = () => {
    this.error = undefined;
    return this.fetch().catch((err) => {
      console.error('Failed to fetch context:', err);
      throw err;
    });
  };
}

export default CustomNetworkContextModel;
